import { computed, openBlock, createElementBlock, normalizeClass, normalizeStyle, createElementVNode } from 'vue';
import propTypes from './utils/prop-types';
import { createComponent } from './utils/create-component';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * kid token
   */
  token: propTypes.string(),
  /**
   * 是否自动执行动画
   */
  anim: propTypes["boolean"]().def(true),
  /**
   * loading图标尺寸
   */
  size: propTypes.number().def(40),
  /**
   * 类型：内置3种颜色
   */
  type: propTypes.string().def('default'),
  /**
   * 图标颜色
   */
  color: propTypes.string(),
  /**
   * 行内展示
   */
  inline: propTypes["boolean"]().def(false)
};

var _createComponent = createComponent('loading'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  setup: function setup(props) {
    var token = props.token;
    var classNames = [className, token, props.inline && "".concat(className, "__inline")];
    var svgClassNames = computed(function () {
      return ["".concat(className, "__").concat(props.type), _defineProperty({}, "".concat(className, "__anim"), props.anim)];
    });
    return {
      classNames: classNames,
      svgClassNames: svgClassNames
    };
  }
});

var _hoisted_1 = /*#__PURE__*/createElementVNode("path", {
  "stroke-dasharray": "160",
  "stroke-linecap": "round",
  d: "M40 40l8.201-8.201c4.53-4.53 11.873-4.53 16.402 0A11.598 11.598 0 0 1 68 40c0 6.405-5.193 11.598-11.598 11.598a11.598 11.598 0 0 1-8.201-3.397L40 40l-8.201-8.201c-4.53-4.53-11.873-4.53-16.402 0A11.598 11.598 0 0 0 12 40c0 6.405 5.193 11.598 11.598 11.598 3.076 0 6.026-1.222 8.201-3.397L40 40z",
  "stroke-width": "7",
  fill: "none",
  "fill-rule": "evenodd"
}, null, -1 /* HOISTED */);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.classNames)
  }, [(openBlock(), createElementBlock("svg", {
    ref: "loading",
    viewBox: "0 0 80 80",
    "class": normalizeClass(_ctx.svgClassNames),
    style: normalizeStyle({
      width: "".concat(_ctx.size, "px"),
      height: "".concat(_ctx.size, "px"),
      stroke: _ctx.color
    })
  }, _hoisted_2, 6 /* CLASS, STYLE */))], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/loading/loading.vue";

var _Loading = script;

export { _Loading as default };
